module.exports = __webpack_public_path__ + "static/media/church.5deeb179.svg";